import React from 'react';
export const WebinarTimeline = () => {
  const steps = [{
    number: 1,
    title: 'Minuut 1-15: Waarom dominantie averechts werkt',
    description: 'Amee legt uit waarom straffen en dominant gedrag vaak het tegengestelde effect heeft van wat je wilt bereiken, en hoe dit spanning creëert in plaats van samenwerking.'
  }, {
    number: 2,
    title: 'Minuut 16-30: Hoe honden natuurlijk communiceren',
    description: 'Je ontdekt hoe honden in de natuur onderling communiceren en welke signalen ze gebruiken om met elkaar en hun omgeving te "praten".'
  }, {
    number: 3,
    title: 'Minuut 31-45: Signalen herkennen en interpreteren',
    description: 'Je leert de belangrijkste lichaamstaal-signalen die elke hond gebruikt, en wat ze werkelijk betekenen in verschillende situaties.'
  }, {
    number: 4,
    title: 'Minuut 45-60: In hun taal terugpraten',
    description: 'Hoe je terug communiceert in hun taal en wat dit betekent voor jullie dagelijkse samenwerking.'
  }, {
    number: 5,
    title: 'Minuut 60-75: Verrassing',
    description: 'Hier onthuld Amee een verrassing voor mensen die nog meer willen leren over honden communicatie en zelf een echte honden gedragsexpert willen worden.'
  }, {
    number: 6,
    title: 'Minuut 75-90: Vraag-en-antwoord',
    description: 'Amee beantwoorden veelgestelde vragen en vragen van deelnemers.'
  }];
  return <section className="mb-12" data-id="element-488">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-489">
        Wat er in die 90 minuten precies gebeurt
      </h2>

      <div className="space-y-6" data-id="element-490">
        {steps.map(step => <div key={step.number} className="flex items-start" data-id="element-491">
            <div className="flex-shrink-0 w-10 h-10 bg-[#1e40af] text-white rounded-full flex items-center justify-center font-bold mr-4 mt-1" data-id="element-492">
              {step.number}
            </div>
            <div data-id="element-493">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-494">{step.title}</h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-495">
                {step.description}
              </p>
            </div>
          </div>)}
      </div>

      <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mt-8 rounded-r-lg" data-id="element-496">
        <p className="text-gray-800 leading-relaxed italic" data-id="element-497">
          "Het mooie is dat mensen tijdens het webinar al anders leren kijken
          naar het gedrag van hun hond," vertelt Amee. "Ze herkennen plotseling
          signalen die ze altijd zagen maar verkeerd interpreteerden, en
          begrijpen hun hond direct beter."
        </p>
      </div>
    </section>;
};